<!-- Modern Compact Job Details Page -->
<div class="modern-job-details-container">
  <!-- Mobile Sidebar (keeping existing functionality) -->
  <mat-drawer-container hasBackdrop="true">
    <mat-drawer #sideNav2 mode="over" position="end" class="mobile-sidebar" [style.width]="'95%'">
      <div class="mobile-content">
        <div class="mobile-header">
          <button class="close-btn" (click)="closeSidebar()">
            <i class="fa fa-times"></i>
          </button>
          <h2 style="text-transform: capitalize;">{{ jobs.productName }}</h2>
        </div>

        <!-- Mobile job content will use same structure as desktop -->
        <div class="mobile-job-content">
          <!-- Same content as desktop version below -->
        </div>
      </div>
    </mat-drawer>

    <!-- Main Desktop Content -->
    <mat-drawer-content>
      <div class="job-details-wrapper">
        <!-- Company Banner Section -->
        <div class="banner-section" *ngIf="portal_details?.portalCompanyBanners?.length">
          <app-carousel [attachments]="portal_details.portalCompanyBanners"
            [storage_url]="'https://storage.googleapis.com/ezeone/icanrefer/'"></app-carousel>
        </div>

        <!-- Two Column Layout -->
        <div class="two-column-layout">
          <!-- Left Column - Job Content -->
          <div class="left-column">
            <!-- Compact Job Header -->
            <div class="job-header-compact">
              <div class="header-left">
                <h1 class="job-title-compact" style="text-transform: capitalize;">
                  <i class="fas fa-briefcase job-title-icon"></i>
                  {{ jobs.productName }}
                </h1>
                <div class="job-meta-compact">
                  <span class="job-code" *ngIf="jobs.productCodeText">{{ jobs.productCodeText }}</span>
                  <!-- <span class="company-name">{{ jobs.employerName || jobs.sellerCompanyName }}</span> -->
                  <span class="posted-date" *ngIf="jobs.postedDate">
                    Posted: {{ jobs.postedDate | UtcToLocalTime | date: "d-MMM-yyyy h:mm a" }}
                  </span>
                </div>
                <div class="application-status-compact" *ngIf="jobs.applied">
                  <div class="status-badge applied">
                    <i class="fa fa-check-circle"></i>
                    Application Submitted
                  </div>
                </div>
              </div>

              <div class="header-right nav-compact">
                <div class="nav-buttons-compact">
                  <button class="nav-btn-compact" (click)="prevNextJob(index, 0)" [disabled]="index === 0">
                    <i class="fa fa-chevron-left"></i>
                  </button>
                  <span class="nav-info-compact">{{ index + 1 }} of {{ job_list.length }} Jobs</span>
                  <button class="nav-btn-compact" (click)="prevNextJob(index, 1)"
                    [disabled]="index === job_list.length - 1">
                    <i class="fa fa-chevron-right"></i>
                  </button>
                </div>
                <!-- <div class="company-logo" *ngIf="portal_settings?.jobLogo?.length">
                  <img 
                    [src]="'https://storage.googleapis.com/ezeone/icanrefer/' + portal_settings.jobLogo[0].cdnPath | safeHTMLPipe:'url'"
                    alt="Company Logo"
                    class="logo-image-compact"
                  />
                </div>
                <button class="action-btn share-btn" (click)="socialMediaShare(jobs)" [title]="'Share Job'">
                  <i class="fa fa-share-alt"></i>
                </button> -->
              </div>


            </div>

            <!-- Single Compact Job Details Card -->
            <div class="job-details-card-compact">
              <h3>
                <i class="fas fa-info-circle job-details-icon"></i>
                Job Details
              </h3>

              <div class="detail-grid-compact">
                <!-- Experience -->
                <div class="detail-item-compact" *ngIf="jobs.expFrom >= 0 || jobs.expTo > 0">
                  <div class="icon-soft experience-soft">
                    <i class="fas fa-user-tie"></i>
                  </div>
                  <div class="content-compact">
                    <div class="value-compact">
                      {{ jobs.expTo > 0 ? jobs.expFrom : 'Fresher' }}
                      <ng-container *ngIf="jobs.expTo && jobs.expTo > 0">
                        - {{ jobs.expTo }} {{ jobs.expTo > 1 ? 'years' : 'year' }}
                      </ng-container>
                    </div>
                    <div class="label-compact">Experience</div>
                  </div>
                </div>

                <!-- Location -->
                <div class="detail-item-compact" *ngIf="jobs.jobLocation">
                  <div class="icon-soft location-soft">
                    <i class="fas fa-map-marker-alt"></i>
                  </div>
                  <div class="content-compact">
                    <div class="value-compact">{{ jobs.jobLocation }}</div>
                    <div class="label-compact">Location</div>
                  </div>
                </div>

                <!-- Job Type -->
                <div class="detail-item-compact" *ngIf="jobs.jobType">
                  <div class="icon-soft jobtype-soft">
                    <i class="fas fa-clock"></i>
                  </div>
                  <div class="content-compact">
                    <div class="value-compact">{{ jobs.jobType }}</div>
                    <div class="label-compact">Job Type</div>
                  </div>
                </div>

                <!-- Openings -->
                <div class="detail-item-compact" *ngIf="jobs.positions">
                  <div class="icon-soft openings-soft">
                    <i class="fas fa-users"></i>
                  </div>
                  <div class="content-compact">
                    <div class="value-compact">{{ jobs.positions }} {{ jobs.positions > 1 ? 'positions' : 'position' }}
                    </div>
                    <div class="label-compact">Openings</div>
                  </div>
                </div>

                <!-- Salary -->
                <div class="detail-item-compact" *ngIf="jobs.expSalaryFrom > 0 || jobs.expSalaryTo > 0">
                  <div class="icon-soft salary-soft">
                    <i class="fas fa-money-bill-wave"></i>
                  </div>
                  <div class="content-compact">
                    <div class="value-compact">
                      {{ jobs.expSalaryCurrSymbol }} {{ jobs.expSalaryFrom }}
                      <ng-container *ngIf="jobs.expSalaryTo > 0">
                        - {{ jobs.expSalaryTo }}
                      </ng-container>
                      {{ jobs.expSalaryScaleDuration }}
                    </div>
                    <div class="label-compact">Salary</div>
                  </div>
                </div>

                <!-- Notice Period -->
                <div class="detail-item-compact" *ngIf="jobs.noticePeriodFrom >= 0 || jobs.noticePeriodTo > 0">
                  <div class="icon-soft notice-soft">
                    <i class="fas fa-calendar-alt"></i>
                  </div>
                  <div class="content-compact">
                    <div class="value-compact">
                      {{ jobs.noticePeriodTo > 0 ? jobs.noticePeriodFrom + ' - ' + jobs.noticePeriodTo + ' days' :
                      'Immediate' }}
                    </div>
                    <div class="label-compact">Notice Period</div>
                  </div>
                </div>
              </div>

              <!-- Required Skills -->
              <div class="skills-section-compact" *ngIf="jobs.keySkills">
                <div class="skills-header">
                  <i class="fas fa-code skills-icon"></i>
                  <h4>Required Skills</h4>
                </div>
                <div class="skills-container-compact">
                  <span class="skill-tag-compact" *ngFor="let skill of jobs.keySkills.split(',')">
                    {{ skill.trim() }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Job Description Section -->
            <div class="description-section-compact">
              <div class="section-card-compact">
                <h3>
                  <i class="fas fa-file-alt job-description-icon"></i>
                  Job Description
                </h3>
                <div class="description-content-compact"
                  [innerHTML]="jobs.description | HTMLFormatter | safeHTMLPipe:'html'"></div>
              </div>
            </div>

            <!-- Additional Information -->
            <div class="additional-info-compact" *ngIf="jobs.education?.length || jobs.industry">
              <div class="section-card-compact">
                <h3>
                  <i class="fas fa-list-ul additional-requirements-icon"></i>
                  Additional Requirements
                </h3>

                <div class="requirement-item-compact" *ngIf="jobs.industry">
                  <h4>Industry</h4>
                  <p>{{ jobs.industry }}</p>
                </div>

                <div class="requirement-item-compact" *ngIf="jobs.education?.length">
                  <h4>Education</h4>
                  <ul>
                    <li *ngFor="let edu of jobs.education">
                      {{ edu.educationTitle }}
                      <span *ngIf="edu.specializationTitle"> - {{ edu.specializationTitle }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Navigation Controls -->
            <!-- <div class="navigation-section-compact" *ngIf="job_list?.length > 1">
              <div class="nav-compact">
                <span class="nav-info-compact">{{ index + 1 }} of {{ job_list.length }} jobs</span>
                <div class="nav-buttons-compact">
                  <button class="nav-btn-compact" (click)="prevNextJob(index, 0)" [disabled]="index === 0">
                    <i class="fa fa-chevron-left"></i>
                  </button>
                  <button class="nav-btn-compact" (click)="prevNextJob(index, 1)"
                    [disabled]="index === job_list.length - 1">
                    <i class="fa fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            </div> -->

            <!-- Back to Jobs Link -->
            <div class="back-to-jobs-compact">
              <a [routerLink]="['/jobs']" class="back-link-compact">
                <i class="fa fa-arrow-left"></i>
                Back to Job Search
              </a>
            </div>
          </div>

          <!-- Right Column - Sticky Apply Card -->
          <div class="right-column">
            <div class="sticky-apply-card">
              <!-- Job Summary in Card -->
              <div class="job-summary-card">
                <div class="job-summary-header">
                  <h4 class="job-title-sidebar" style="text-transform: capitalize;">{{ jobs.productName }}</h4>
                  <!-- <p class="company-name-sidebar">{{ jobs.employerName || jobs.sellerCompanyName }}</p> -->
                  <div class="posted-info">
                    <small *ngIf="jobs.postedDate">Posted on {{ jobs.postedDate | UtcToLocalTime | date:'d MMM yyyy'
                      }}</small>
                  </div>
                </div>

                <!-- Apply Button Section -->
                <div class="apply-section">
                  <div class="apply-status" *ngIf="jobs.applied">
                    <div class="applied-badge">
                      <i class="fa fa-check-circle"></i>
                      <span>Application Submitted</span>
                    </div>
                    <p class="applied-message">Your application has been successfully submitted.</p>
                  </div>

                  <div class="apply-actions" *ngIf="!jobs.applied">
                    <button class="apply-btn-card" (click)="applyJob(jobs)">
                      <i class="fa fa-paper-plane"></i>
                      Apply for this Job
                    </button>
                    <p class="apply-note">Quick and easy application process</p>
                  </div>
                </div>

                <!-- Additional Actions -->
                <div class="additional-actions">
                  <button class="action-btn-secondary" (click)="socialMediaShare(jobs)">
                    <i class="fa fa-share-alt"></i>
                    Share Job
                  </button>
                </div>

                <!-- Posted Date -->
                <!-- <div class="posted-info" *ngIf="jobs.postedDate">
                  <small>Posted on {{ jobs.postedDate | UtcToLocalTime | date:'d MMM yyyy' }}</small>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>